import googleTagManager from "@analytics/google-tag-manager"
import Analytics from "analytics"
import { browserName, deviceType, osName } from "react-device-detect"

const GTM_ID = process.env.GTM_ID

if (!GTM_ID) {
  throw new Error("Please provide the GTM_ID environment variable.")
}

/* Initialize analytics & load plugins */
const analytics = Analytics({
  app: "McDonalds Gift Cards",
  plugins: [googleTagManager({ containerId: GTM_ID })],
})

export const trackPage = () => {
  analytics.page()
}

// export const trackTechnicalSpecificationExpand = (data: {
//   stepName: string
//   buttonText: string
// }) =>
//   analytics.track("technical_specification_expand", {
//     step: data.stepName,
//     model: "geometry c",
//     text: data.buttonText,
//   })

export const productDetailView = (
  categoryName: string,
  id: number,
  productName: string
) => {
  analytics.track("productDetailView", {
    ecommerce: {
      currencyCode: "ILS",
      detail: {
        actionField: {
          list: categoryName,
        },
        products: [
          {
            id: id,
            sku: null,
            name: productName,
            brand: "McDonalds",
            category: "GiftCard",
          },
        ],
      },
    },
  })
}

export const addToCart = (id: number, productName: string, price: number) => {
  analytics.track("addToCart", {
    ecommerce: {
      currencyCode: "ILS",
      add: {
        products: [
          {
            id: id,
            sku: null,
            name: productName,
            brand: "McDonalds",
            category: "GiftCard",
            price: price,
          },
        ],
      },
    },
  })
}

export const purchase = (products: {}, actionField: {}, callback) => {
  analytics.track(
    "purchase",
    {
      ecommerce: {
        purchase: {
          actionField: actionField,
          products: [products],
        },
      },
      "Is First": true,
    },
    null,
    callback
  )
}

export const checkout = (step: number, product: {}) => {
  analytics.track("checkout", {
    ecommerce: {
      checkout: {
        actionField: { step: step, option: "creditcard" },
        products: [product],
      },
    },
  })
}

export const checkBalance = () => {
  analytics.track("checkBalance", {
    step: "chooseIDCheck",
  })
}

export const leaveBalancePage = (type: string, balanceLeft?: number) => {
  analytics.track("checkBalance", {
    step: "balanceLeft",
    idCheckWay: type,
    balanceLeft: balanceLeft,
  })
}

export const videoAudioError = (
  ViewType: string,
  errorType: string,
  error: string
) => {
  analytics.track("error-permission", {
    ViewType: ViewType,
    "error-type": errorType,
    "browser-error-message": error,
    OS: osName,
    browser: browserName,
    device: deviceType,
  })
}
